import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'createNewProjectClick',
  'newTranslationProjectSelected',
  'newRecordingProjectSelected',
  'extensionInstallPromptViewed',
  'extensionInstallClicked',
  'extensionInstallSuccess',
  'extensionDetected',
  'extensionOpened',
  'recordingPageViewed',
  'recordingStatusCompleted',
  'recordingStatusFailed',
  'recordingStatusAborted',
  'recordingTabSwitched',
  'recordingDownloadClicked',
  'recordingDownloadCompleted',
  'recordingDownloadFailed',
  'recordingRetryClicked',
  'recordingRated',
  'recordingFeedbackClicked',
  'recordingSignUp',
  'recordingSignIn',
  'recordingAuthenticate',
  'desktopRequiredStateShown',
  'chromeRequiredStateShown',
  'recordingStartFromDashboardClickEntryPoint',
  'recordingStartFromExtensionClickEntryPoint',
  'extensionInstallClick',
  'extensionInstallPromptDismiss',
  'extensionSignInPromptViewed',
  'extensionSignInPromptProceedClick',
  'extensionSignInPromptCanceled',
  'extensionSignInSuccessful',
  'recordingProjectOpened',
  'recordingProjectProcessingScreenViewed',
  'recordingProjectProcessingFailed',
  'recordingProjectProcessingSucceeded',
  'recordingProjectResultScreenViewed',
  'recordingProjectExportClick',
  'recordingProjectDownloadClick',
  'recordingProjectDownloadSuccess',
  'recordingProjectShareClick',
  'recordingEditorOpened',
  'recordingEditorOnboardingStarted',
  'recordingEditorOnboardingStepShown',
  'recordingEditorOnboardingStepCompleted',
  'recordingEditorOnboardingCompleted',
  'transcriptSpeechSegmentRemoved',
  'transcriptSpeechSegmentRestored',
  'recordingProjectLocalizeClick',
  'recordingProjectLocalizeSuccess',
] as const;

export const screenRecordEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
